import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import styles from "./FilterModal.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { getAllProjects, setFilters } from "reducer/admin/projectMonitoringSlice";
import { flagStatusOptions, statusOptions } from "constants/constants";
import SelectCustom from "components/common/Select/Select";
import { selectDropdownStyles } from "../constants";

const FilterModal = ({ onClose, searchTerm }) => {

  const dispatch = useDispatch();

  const { filters } = useSelector(
    (state) => state.projects
  );

  const formDropdownFields = [
    { label: "Status", key: "status", options: statusOptions },
    { label: "Flag Status", key: "flaggedStatus", options: flagStatusOptions }
  ];

  const {
    control,
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      fromDate: filters.fromDate?.split("T")[0] || "",
      toDate: filters.toDate?.split("T")[0] || "",
      status: filters.status || null,
      flaggedStatus: filters.flaggedStatus || null,
    },
  });

  // const watchFromDate = watch("fromDate");
  const watchToDate = watch("toDate");

  const onSubmit = (data) => {
    const payload = {
      ...data,
      fromDate: data.fromDate ? new Date(data.fromDate).toISOString() : "",
      toDate: data.toDate ? new Date(data.toDate).toISOString() : "",
    };
    dispatch(setFilters(payload));
    dispatch(getAllProjects({ pageSelected: 1, search: searchTerm, filters: payload }));
    onClose();
  };

  const resetAll = () => {
    reset({
      fromDate: "",
      toDate: "",
      status: "",
      flaggedStatus: "",
    });

    dispatch(setFilters({ fromDate: "", toDate: "", status: "", flaggedStatus: "" }));
    dispatch(getAllProjects({ pageSelected: 1, search: searchTerm, filters: {} }));
    onClose();
  };

  const isFilterActive = () => {
    const values = watch();
    return values.fromDate || values.toDate || values.status || values.flaggedStatus;
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className={styles.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <form onSubmit={handleSubmit(onSubmit)} className={styles.modal}>
        <div className={styles.dragBar} />
        <p className={styles.title}>Filter by:</p>

        {/* Date Range */}
        <div className={styles.section}>
          <div className={styles.labelRow}>
            <label>Date Range</label>
            <button
              type="button"
              onClick={() => {
                setValue("fromDate", "");
                setValue("toDate", "");
              }}
            >
              Reset
            </button>
          </div>
          <div className={styles.dateRow}>
            <input
              type="date"
              {...register("fromDate", {
                validate: (from) => {
                  const to = watchToDate;
                  return !from || !to || new Date(from) <= new Date(to) || "please select a valid date range";
                },
              })}
            />
            <input
              type="date"
              {...register("toDate", {
                // validate: (to) => {
                //   const from = watchFromDate;
                //   return !to || !from || new Date(from) <= new Date(to) || "To Date should be after From Date";
                // },
              })}
            />
          </div>
          {errors.fromDate && <p className={styles.error}>{errors.fromDate.message}</p>}
          {errors.toDate && <p className={styles.error}>{errors.toDate.message}</p>}
        </div>

        {formDropdownFields?.map(({ label, key, options }) => (
          <div className={styles.section} key={key}>
            <div className={styles.labelRow}>
              <span>{label}</span>
              <button
                type="button"
                onClick={() => {
                  setValue(key, "");
                }}
              >
                Reset
              </button>
            </div>
            <Controller
              name={key}
              control={control}
              render={({ field }) => {
                let selectedOption;
                if (field.value) {
                  selectedOption = options.find(option => option.value === field.value);
                } else {
                  selectedOption = ""
                }
                return (
                  <SelectCustom
                    {...field}
                    options={options}
                    value={selectedOption}
                    styles={selectDropdownStyles()}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption?.value);
                    }}
                  />
                );
              }}
            />
          </div>
        ))}

        {/* Footer */}
        <div className={styles.footer}>
          <button
            type="button"
            className={`${styles.resetBtn} ${!isFilterActive() ? styles.disabled : ""}`}
            onClick={resetAll}
            disabled={!isFilterActive()}
          >
            Reset All
          </button>
          <button
            type="submit"
            className={`${styles.applyBtn} ${!isFilterActive() ? styles.disabled : ""}`}
            disabled={!isFilterActive()}
          >
            Apply Filters
          </button>
        </div>
      </form>
    </div>
  );
};

export default FilterModal;
